module.exports = __webpack_public_path__ + "img/con2.4425eec4.png";